<style>

.prompt{
    display: grid;
    grid-template-columns: 2;
    color: white;
    position: fixed;
    z-index: 1000;
	top: 30%;
	/* bottom: 10%; */
	left: 50%;
	width: 330px;
	margin-left: -165px;
}

.icon-help_outline {
    font-size: 40px;
}

.grid-item1 {
    grid-column: 1;
}

.grid-item2 {
    grid-column: 2;
    margin-left: 5%;
    font-size: 80%;
    font-style: italic;
}

</style>

<div class="prompt">
    <div class="grid-item1"><i class="icon-help_outline"></i></div>
    <div class="grid-item2">All feedback goes to the event organizare along with the HOT support team</div>
</div>

<script>

</script>